export const hasText = (values, text) => {
  let hasSearchText = false;
  values.forEach(value => {
    const _value = value ? value.toLowerCase() : value || '';
    hasSearchText = _value.includes(text.toLowerCase()) || hasSearchText;
  });

  return hasSearchText;
};



// WEBPACK FOOTER //
// ./src/utils/hasText.js